import Vue from 'vue'
import App from './App.vue'
import Firebase from "./firebase"
import router from './router'
import store from './store'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto'
import Ads from 'vue-google-adsense'
 
Vue.use(require('vue-script2'))
 
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(VueScrollTo, {
  duration: 700,
  easing: [0, 0, 0.1, 1],
  offset: 0
})

Vue.use(VueLazyload)

Vue.use(VueAnalytics, {
  id: 'UA-146875415-1',
  router
})

Vue.use(Buefy)

Firebase.init();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
